import { render } from "./RegistrosView.vue?vue&type=template&id=8f552186&scoped=true"
import script from "./RegistrosView.vue?vue&type=script&lang=js"
export * from "./RegistrosView.vue?vue&type=script&lang=js"

import "./RegistrosView.vue?vue&type=style&index=0&id=8f552186&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f552186"]])

export default __exports__